import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const SearchCompletionsDefaultProps = {
  ...ClassNameDefaultProps,
  completions: [],
  isLoading: false,
  onItemKeyDown: () => null,
  selectCompletion: () => null,
  setItemRef: () => null,
};

export const SearchCompletionsPropTypes = {
  ...ClassNamePropTypes,
  completions: PropTypes.arrayOf(
    PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.string),
      key: PropTypes.string,
    }),
  ),
  isLoading: PropTypes.bool,
  onItemKeyDown: PropTypes.func,
  selectCompletion: PropTypes.func,
  setItemRef: PropTypes.func,
};
